// extracted by mini-css-extract-plugin
module.exports = {"clock":"DailyRewardTimer_clock__1adfO","dailyRewardTimer":"DailyRewardTimer_dailyRewardTimer__ClQW1"};